import React, { useState} from 'react';
import * as Icon from 'react-feather';
import Lightbox from 'react-18-image-lightbox';
import 'react-18-image-lightbox/style.css';
import { Col, Row, Card, CardBody, Container } from "reactstrap";
import { Link as ScrollLink } from 'react-scroll';
import { Link as RouterLink } from 'react-router-dom';
import parseHtml from '../utils/parseHtml';
import { getPayloadMedia } from '../services/payloadService';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper';
import "swiper/swiper.scss";
import "swiper/components/navigation/navigation.scss";
import "swiper/components/pagination/pagination.scss";

SwiperCore.use([Autoplay, Navigation, Pagination]);

export default function OtrosServiciosLista({ titulo, subtitulo, imagenFondo, id, servicios, configuracion }) {
    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);


    // Extraer imágenes para el lightbox
    const images = servicios?.map(servicio =>
        getPayloadMedia(servicio.imagen?.url)
    ).filter(Boolean);

    // Función para renderizar una card de servicio
    const renderServicioCard = (servicio, index) => {
        const imagenUrl = getPayloadMedia(servicio.imagen?.url);
        const titulo = servicio.titulo || 'Sin título';
        const subtitulo= servicio.subtitulo || '';
        const descripcion = servicio.descripcion || '';
        const destacado = servicio.destacado || false;

        return (
            <Card className={`border-0 project project-primary position-relative d-block overflow-hidden rounded ${destacado ? 'project-destacado' : ''}`} key={servicio.id}>
                <CardBody className="p-0">
                    <img
                        src={imagenUrl}
                        className="img-fluid"
                        alt={titulo}
                        style={{height: '500px', objectFit: 'cover', width: '100%'}}
                    />
                    <div className="overlay-work bg-dark"></div>
                    <div className="content px-1">
                        <h4 className="mb-0">
                            <RouterLink to={"#"} className="text-white title">{titulo}</RouterLink>
                        </h4>
                        <p className="text-light tag mb-0">{subtitulo}</p>
                        <p className="text-light tag mb-0 mt-2 mb-2">{descripcion}</p>
                        {servicio.tipoBoton === 'whatsapp' ? (
                            <a
                                href={`https://wa.me/${configuracion?.telefono?.replace(/\D/g, '')}?text=${encodeURIComponent(`Hola, quiero cotizar este servicio: ${titulo}`)}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={'btn btn-primary-whatsapp'}
                            >
                                <i className="uil uil-whatsapp me-2" style={{fontSize: '20px'}}></i>
                                {servicio.botonTextoPersonalizado || 'Cotizar'}
                            </a>
                        ) : (
                            servicio.botonTextoPersonalizado && (
                                servicio.botonLinkPersonalizado && servicio.botonLinkPersonalizado.startsWith('#') ? (
                                        <ScrollLink to={servicio.botonLinkPersonalizado.substring(1)} spy={true} smooth={true} duration={500} className={'btn btn-primary'}>{servicio.botonTextoPersonalizado}</ScrollLink>
                                    ):(
                                    <RouterLink to={servicio.botonLinkPersonalizado || "#"} className={'btn btn-primary'}>{servicio.botonTextoPersonalizado}</RouterLink>
                                )
                            )
                        )}
                    </div>
                    <div className="icons text-center">
                        <RouterLink
                            to="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setPhotoIndex(index);
                                setIsOpen(true);
                            }}
                            className="btn btn-icon btn-pills lightbox"
                        >
                            <Icon.Camera className="fea icon-sm image-icon" />
                        </RouterLink>
                    </div>
                </CardBody>
            </Card>
        );
    };

    return (
        <>
            {/* Project Start  */}
            <section
                className="section"
                id={id || 'portfolio'}
                style={{background: imagenFondo ? `url(${getPayloadMedia(imagenFondo.url || imagenFondo[0]?.url)}) center no-repeat` : '', backgroundSize: 'cover' }}
            >
                <Container>
                    <Row className="justify-content-center">
                        <Col>
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">{titulo}</h4>
                                <p className="text-body mx-auto para-desc mb-0">{parseHtml(subtitulo)}</p>
                            </div>
                        </Col>
                    </Row>

                    {servicios?.length === 0 ? (
                        <Row className="justify-content-center">
                            <Col className="text-center">
                                <p className="text-muted">No hay otros servicios disponibles en este momento.</p>
                            </Col>
                        </Row>
                    ) : (
                        <>
                            {/* Carousel para desktop/laptop - visible solo en lg y arriba */}
                            <div className="swiper-slider-otros-servicios d-none d-lg-block">
                                <Swiper
                                    spaceBetween={30}
                                    slidesPerView={3}
                                    pagination={{ clickable: true }}
                                    loop
                                    navigation
                                    breakpoints={{
                                        1200: {
                                            slidesPerView: 3,
                                            spaceBetween: 30,
                                        },
                                        992: {
                                            slidesPerView: 2,
                                            spaceBetween: 20,
                                        }
                                    }}
                                >
                                    {servicios?.map((servicio, index) => (
                                        <SwiperSlide key={servicio.id} className="mt-4 pt-2">
                                            {renderServicioCard(servicio, index)}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>

                            {/* Grid normal para móviles y tablets - oculto en lg y arriba */}
                            <Row className="d-lg-none">
                                {servicios?.map((servicio, index) => (
                                    <Col lg={4} md={6} className="col-12 mt-4 pt-2" key={servicio.id}>
                                        {renderServicioCard(servicio, index)}
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}
                    <>
                        {isOpen && (
                            <Lightbox
                                mainSrc={images[photoIndex]}
                                nextSrc={images[(photoIndex + 1) % images.length]}
                                prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                                onCloseRequest={() => setIsOpen(false)}
                                onMovePrevRequest={() =>
                                    setPhotoIndex(
                                        (photoIndex + images.length - 1) % images.length,
                                    )
                                }
                                onMoveNextRequest={() =>
                                    setPhotoIndex(
                                        (photoIndex + 1) % images.length,
                                    )
                                }
                            />
                        )}
                    </>
                </Container>
            </section>
            {/* Project End  */}
        </>
    )
}